import { type FC } from "react";

import { css } from "@emotion/css";

import { fontFamily } from "../styles";

const placeholder = css`
    ${fontFamily};
    position: absolute;

    margin: 0 2px;

    font-size: 14px;
    font-weight: 400;
    line-height: 16px;
    color: #858d94;
`;

export const SelectSingleValuePlaceholder =
    (text: string): FC =>
    () => <span className={placeholder}>{text}</span>;
